import { Box, Divider, Flex, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider/AuthProvider";
import { useTranslation } from "react-i18next";
import MobileMenu from "../MobileMenu/MobileMenu";
import { Link } from "react-router-dom";

const Menu = ({ variant = "default" }) => {
    const navigate = useNavigate();
    const { t } = useTranslation("default");
    const { user, logout, isSuperAdmin } = useAuth();

    const ROUTES = [
        {
            label: t('menu.nav.main'),
            route: '/'
        },
        {
            label: t('menu.nav.setup'),
            route: '/setup'
        },
        {
            label: t('menu.nav.categories'),
            route: '/categories',
            protected: isSuperAdmin()
        },
        {
            label: t('menu.nav.users'),
            route: '/users',
            protected: isSuperAdmin()
        },
    ];

    const handleAction = () => {
        if (user) {
            logout();
        } else {
            navigate('/login');
        }
    }

    return (
        <Flex bg={'#089A7A'} w={'100%'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}
            position="sticky" top="0" zIndex="999">
            <Flex bg={'#089A7A'} w={'100%'} py='12px' px={4} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
                <Flex w="100%" maxW="7xl" justifyContent={'space-between'} alignItems={'center'}>
                    <Box w={"full"} display={'flex'} justifyContent="space-between" alignItems="center" columnGap={4}>

                        <Flex w={"full"} className='menu-nav' gap={{ base: '16px', lg: '64px' }}>
                            <a href="https://evenado.com">
                                <Text fontFamily={'Oi'} fontWeight={'400'} fontSize={{ base: '16px', md: '28px' }} color={'#FFFFFF'}>
                                    Evenado.
                                </Text>
                            </a>
                            <Flex w={"full"} justifyContent="space-between" alignItems="center" gap={{ base: '16px', lg: '64px' }}>
                                <Flex gap={{ base: '16px', lg: '64px' }} position={'relative'} display={{ base: 'none', lg: 'flex' }}>
                                    {user && <>
                                        <Link to="/" className='link'>
                                            {t('menu.nav.main')}
                                        </Link>

                                        <Link to="/setup" className='link'>
                                            {t('menu.nav.setup')}
                                        </Link>

                                        {isSuperAdmin() && (
                                            <Link to="/categories" className='link'>
                                                {t('menu.nav.categories')}
                                            </Link>
                                        )}

                                        {isSuperAdmin() && (
                                            <Link to="/users" className='link'>
                                                {t('menu.nav.users')}
                                            </Link>
                                        )}

                                    </>}
                                </Flex>
                                {variant === "default" ? (
                                    <Button
                                        display={{ base: 'none', lg: 'flex' }}
                                        bg="transparent"
                                        _hover={{ bgColor: 'transparent' }}
                                        w="152px"
                                        h="49px"
                                        color="white"
                                        borderRadius="100"
                                        fontWeight="400"
                                        border="1px"
                                        borderColor="#FFFFFF"
                                        onClick={handleAction}
                                    >
                                        {t(user ? 'menu.logout' : 'menu.login')}
                                    </Button>
                                ) : (
                                    <Button
                                        display={{ base: 'none', lg: 'flex' }}
                                        bg="white"
                                        _hover={{ bgColor: 'white' }}
                                        w="215px"
                                        h="48px"
                                        color="#0A4725"
                                        borderRadius="0"
                                        gap="10px"
                                        fontFamily="Poppins"
                                        fontWeight="600"
                                        fontSize="14px"
                                        border="2px"
                                        borderColor="#0A4725"
                                        as="a"
                                        href="#"
                                        onClick={() => { navigate("/") }}
                                    >
                                        {t('check.events')}
                                        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.5 0H4.08481L8.5 5L4.08481 10H0.5L4.93544 5L0.5 0Z" fill="#0A4725" />
                                        </svg>
                                    </Button>
                                )}
                            </Flex>
                        </Flex>
                    </Box>
                    <MobileMenu routes={ROUTES} />
                </Flex>
            </Flex>
            <Divider borderColor={'#A2C2B0'} display={{ base: 'none', lg: 'block' }} />
        </Flex>
    )
}

export default Menu;
